@let item = artwork();
@let art = item.fullArtwork;
@if (art) {
  <div class="" [class.cart-summary]="cartSummary()">
    <div class="flex flex-col md:flex-row md:space-x-6" [class.opacity-60]="art.soldOut">
      <div class="flex flex-col">
        <div class="relative w-full md:w-48">
          <img [src]="art?.mainAttachment?.url" class="w-full rounded shadow" [class.grayscale]="art.soldOut" />
          @if (art.soldOut) {
            <span class="absolute top-2 left-2 bg-soldOut text-white text-xs font-bold uppercase px-2 py-1 rounded shadow">
              Sold Out
            </span>
          }
        </div>
        <div class="my-4">
          <label class="font-semibold text-gray-700">Quantity:</label>
          <input
            type="number"
            [disabled]="art.isUnique"
            [readonly]="!editable()"
            class="border rounded px-3 py-1 w-24 ml-2"
            min="1"
            [max]="art.unitAvailable"
            [(ngModel)]="item.qty"
            (change)="cartService.updateCart(item)"
          />
        </div>

        <!-- Remove Btn -->
        @if (editable()) {
          <button (click)="cartService.remove(item)" wunButton light class="mb-4 px-4 py-2 border rounded flex items-center space-x-2 hover:bg-gray-100">
            <wun-trash-icon wunIcon></wun-trash-icon>
            Remove
          </button>
        }

      </div>
      <div class="flex-1">
        <h2 class="text-xl font-thin mt-4 md:mt-0">{{art.name}}</h2>
        <p class="text-lg font-bold mt-1">{{art.price | currency : 'EUR' : '   €' : '1.2-2' }}</p>

        <p>
          {{art.year}}
        </p>
        <p>
          {{art.width}}x{{art.height}}, {{art.technique}}
        </p>
        <p class="text-sm text-gray-700 mt-2">
          <span class="font-semibold">Description:</span> <br>
          {{art.description}}
        </p>

      </div>
    </div>
  </div>
}
